import dayjs from 'dayjs';

/**
 * 주어진 시점 기준 지난달을 1-indexed 월 숫자로 반환한다.
 *
 * 예) 2026년 2월 → 1, 2026년 1월 → 12, 2026년 12월 → 11.
 *
 * `dayjs().month()`는 0-indexed이므로 단순히 `.month() - 1`로 계산하면
 * 1월에 `-1`이 된다. 이 함수는 1월일 때 12로 보정한다.
 *
 * 주 용도: 랭킹 UI 등에서 "지난달 데이터"를 레이블링할 때.
 */
export const getLastMonth = (now: dayjs.Dayjs = dayjs()): number => {
  const m = now.month();
  return m === 0 ? 12 : m;
};
